import { set } from 'lodash';
import React, { useState, useEffect } from 'react';

const LoyaltyTiers = ({ lang, expandTiers }) => {
  const [showTiers, setShowTiers] = useState(true);
  const [hideExpander, setHideExpander] = useState(false);

  const copyStrings = {
    en: {
      heading: 'What’s my Cocktail Lounge tier?',
      tableHeading: 'Benefits',
      tableColHeader1: 'Spirited Server',
      tableColDesc1: '0-100 points',
      tableColHeader2: 'Badass Bartender',
      tableColDesc2: '101-250 points',
      tableColHeader3: 'Mighty Mixologist',
      tableColDesc3: '251+ points',
      tableRowDesc1: 'You’re In Welcome Reward!',
      tableRowDesc2: 'Another Year Birthday Reward',
      tableRowDesc3: 'Happy Hour in Hell Monthly Recipes (recipe for monthly cocktail and “appie”)',
      tableRowDesc4: 'Save Big Seasonal Savings',
      tableRowDesc5: 'Another Day in Hell Free Magnet & Stickers',
      tableRowDesc6: 'Another Day in Hell Free Mug',
      tableRowDesc7: 'Two is better than One Free Cocktail Mixer 2-pack',
    },
  };

  const toggleTiers = () => {
    setShowTiers(!showTiers);
  };

  useEffect(() => {
    // on mount
    if (expandTiers) {
      setShowTiers(true);
      setHideExpander(true);
    }
  }, []);

  return (
    <div className={!hideExpander ? 'custom-tiers__breakdown' : 'custom-tiers__breakdown -slim'}>
      <div className={!hideExpander ? 'custom-tiers__inner' : 'custom-tiers__inner -slim'}>
        {!hideExpander
        && (
        <div className="custom-tiers__heading" onClick={(e) => toggleTiers()}>
          {copyStrings[lang].heading}
          <a><img className={showTiers ? '-rotate' : ''} src="https://assets.heyethos.com/bonlook/landing/icon-down-arrow.png" alt="What’s my Trendsetter tier?" /></a>
        </div>
        )}
        {showTiers
        && (
        <div className={!hideExpander ? 'custom-tiers__table' : 'custom-tiers__table -slim'}>
          <table>
            <tr>
              <th>{copyStrings[lang].tableHeading}</th>
              <th>
                {copyStrings[lang].tableColHeader1}
                <span>{copyStrings[lang].tableColDesc1}</span>
              </th>
              <th>
                {copyStrings[lang].tableColHeader2}
                <span>{copyStrings[lang].tableColDesc2}</span>
              </th>
              <th>
                {copyStrings[lang].tableColHeader3}
                <span>{copyStrings[lang].tableColDesc3}</span>
              </th>
            </tr>
            <tr>
              <td>{copyStrings[lang].tableRowDesc1}</td>
              <td>&bull;</td>
              <td>&bull;</td>
              <td>&bull;</td>
            </tr>
            <tr>
              <td>{copyStrings[lang].tableRowDesc2}</td>
              <td>&bull;</td>
              <td>&bull;</td>
              <td>&bull;</td>
            </tr>
            <tr>
              <td>{copyStrings[lang].tableRowDesc3}</td>
              <td>&bull;</td>
              <td>&bull;</td>
              <td>&bull;</td>
            </tr>
            <tr>
              <td>{copyStrings[lang].tableRowDesc4}</td>
              <td></td>
              <td>&bull;</td>
              <td>&bull;</td>
            </tr>
            <tr>
              <td>{copyStrings[lang].tableRowDesc5}</td>
              <td>&bull;</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>{copyStrings[lang].tableRowDesc6}</td>
              <td></td>
              <td>&bull;</td>
              <td></td>
            </tr>
            <tr>
              <td>{copyStrings[lang].tableRowDesc7}</td>
              <td></td>
              <td></td>
              <td>&bull;</td>
            </tr>
          </table>
        </div>
        )}
      </div>
    </div>
  );
};
export default LoyaltyTiers;
